{
  "common" : {
    "customFieldExistsError" : "Ya existe un campo personalizado con este nombre",
    "uniqueKeyNotUniqueError" : "Esta clave no es única",
    "save" : "Guardar",
    "saving" : "Guardando",
    "integrate" : "Integrar",
    "preview" : "Previsualizar",
    "back" : "Atrás",
    "alert" : "Alerta",
    "proceed" : "Proceder",
    "cancel" : "Cancelar",
    "delete" : "Borrar",
    "embed" : "Insertar",
    "link" : "Enlazar",
    "iframeEmbed" : "Incrustación de iframe",
    "styles" : "Estilos",
    "options" : "Opciones",
    "quickAdd" : "Añadir rápidamente",
    "customFields" : "Campos personalizados",
    "addObjectFields" : "Añadir campos de objeto",
    "personalInfo" : "Información personal",
    "contactInfo" : "Información de contacto",
    "submit" : "Enviar",
    "address" : "Dirección",
    "customized" : "Personalizado",
    "layout" : "Diseño",
    "showLabel" : "Mostrar etiqueta",
    "background" : "Fondo",
    "buttonBackground" : "Fondo del Botón",
    "fontColour" : "Color de la Fuente",
    "textFontColour" : "Text Font Colour",
    "subTextFontColour" : "Sub Text Font Colour",
    "selectThemes" : "Seleccionar tema",
    "filled" : "Rellenado",
    "textOnly" : "Solo cuerpo",
    "border" : "Borde",
    "borderType" : "Tipo de borde",
    "cornerRadius" : "Radio de la esquina",
    "width" : "Ancho",
    "padding" : "Margen",
    "top" : "Superior",
    "bottom" : "Inferior",
    "left" : "Izquierda",
    "right" : "Derecha",
    "center" : "Centrar",
    "default" : "Por defecto",
    "formDefault" : "Formulario por defecto",
    "shadow" : "Sombra",
    "color" : "Color",
    "horizontal" : "Horizontal",
    "vertical" : "Vertical",
    "blur" : "Difuminar",
    "spread" : "Propagar",
    "fieldStyle" : "Estilo de campo",
    "fontColor" : "Color de la fuente",
    "inputTextFillColor" : "Color de relleno del comentario/opinión",
    "inputTextColor" : "Color del texto del comentario",
    "primaryColor" : "Color principal",
    "primaryColorTooltip" : "Controla el Color para el estado de desplazamiento y el estado Dinámico.",
    "inputTextColorTooltip" : "Controla el Color del texto escrito en los Campos de comentario/opinión.",
    "mapPrimaryColorToButtonColor" : "Asigna el color principal al color del botón",
    "label" : "Etiqueta",
    "fontFamily" : "Familia tipográfica",
    "size" : "Tamaño",
    "weight" : "Peso",
    "placeholder" : "Marcador de posición",
    "customCSS" : "CSS personalizado",
    "backgroundImage" : "Imagen de fondo",
    "headerImage" : "Imagen de cabecera",
    "miscellaneous" : "Miscelánea",
    "agencyBranding" : "Elementos de marca de la agencia",
    "imageUploadMessage" : "Haz clic o arrastra un archivo de imagen a esta área para subirlo",
    "backgroundImageTooltipMessage" : "La imagen de fondo está pensada para cubrir toda la página, proporcionando un telón de fondo visualmente atractivo para el formulario. Para ver la imagen de fondo, haz clic en la opción de previsualización.",
    "headerImageTooltipMessage" : "La imagen del encabezado está diseñada para cubrir todo el ancho del formulario y permanece posicionada en la parte superior del formulario. Para ver la imagen del encabezado, haz clic en la opción de previsualización.",
    "onSubmit" : "Al enviar",
    "facebookPixelID" : "ID de píxel de Facebook",
    "facebookPixelIDMessage" : "Ignora este campo si planeas usar este formulario/encuesta dentro de un embudo",
    "facebookPixelEvents" : "Eventos de píxel de Facebook",
    "onpageView" : "En vista de página",
    "stickyContact" : "Contacto fijo",
    "stickyContactMessage" : "Remembers and auto-fills contact details when the user returns on the same device and browser.",
    "fieldDescription" : "Descripción del campo",
    "fieldTitle" : "Título del campo",
    "queryKey" : "Clave de consulta",
    "querykeyTooltipMessage" : "La clave de consulta que puede usarse como parámetro de URL para rellenar este campo",
    "required" : "Obligatorio",
    "hidden" : "Oculto",
    "hiddenValue" : "Valor oculto",
    "enableCountryPicker" : "Habilitar el selector de países",
    "altText" : "Texto alternativo",
    "alignment" : "Alineación",
    "imageWidth" : "Ancho de la imagen",
    "imageHeight" : "Altura de la imagen",
    "logic" : "Lógica",
    "pleaseInput" : "Introduce",
    "editHTML" : "Editar HTML",
    "textStyle" : "Estilo de texto",
    "subText" : "Subtexto",
    "text" : "Texto",
    "buttonStyle" : "Estilo de botón",
    "fullWidth" : "Ancho completo",
    "htmlMessage" : "El HTML personalizado va aquí",
    "htmlEditorHeader" : "JAVASCRIPT / HTML PERSONALIZADO",
    "htmlEditorBodyMessage" : "Añade tu código aquí",
    "yesSave" : "Sí, Guardar",
    "cancelKeep" : "Cancelar, mantener",
    "done" : "Hecho",
    "addElement" : "Añadir elemento",
    "addUrlLike" : "Añade URL válidas como",
    "doNotAddRelativePath" : "No añadas rutas relativas como",
    "or" : "o",
    "addCustomFields" : "Añadir campos personalizados",
    "customFieldSearch" : "Buscar por nombre",
    "enterSourceValue" : "Introduce el valor de origen",
    "shortLabel" : "Etiqueta corta",
    "shortLabelPlaceholder" : "Fuente a Etiqueta corta",
    "labelPlaceholder" : "Tipo una etiqueta",
    "fileUploadPlaceholder" : "Subir a Archivo",
    "customCSSTooltip" : "Los CSS personalizados tienen prioridad sobre el estilo del formulario y los temas y pueden tener un impacto en el estilo del tema.",
    "fontFamilyTooltip" : "El creador admite todo tipo de fuentes, aunque no puedas verla en la lista. Búscala en el menú desplegable.",
    "useGDPRCompliantFont" : "Usa una fuente compatible con el RGPD",
    "enableTimezone" : "Habilitar zona horaria",
    "inputStyle" : "Estilo de entrada",
    "conditionalLogicAlertOnSubmit" : "La lógica condicional tendrá prioridad sobre el mensaje/redirigirá aquí",
    "conditionalLogicAlertOnShowHide" : "La lógica condicional tendrá prioridad sobre la configuración oculta aquí",
    "placeholderFacebookPixelIdInput" : "Introduce el ID de píxel de Facebook",
    "doNotShowMessage" : "No mostrar de nuevo",
    "creatingForm" : "Creada tu Formulario...",
    "creatingSurvey" : "Creada tu Encuesta...",
    "creatingQuiz" : "Creada tu cuestionario...",
    "errorCreatingForm" : "Hay un error Creada tu formulario. Por favor, Vuelva a intentarlo.",
    "errorCreatingSurvey" : "Hay un error Creada tu Encuesta. Por favor, Vuelva a intentarlo.",
    "errorCreatingQuiz" : "Ha habido un error Creada tu cuestionario. Por favor, Vuelva a intentarlo.",
    "redirectMessage" : "You will be redirected to:",
    "themes" : {
      "themes" : "Temas",
      "alertThemeMessage" : "Cambiar de tema hará que se pierdan todas las modificaciones de estilo actuales.",
      "useTheme" : "Usar tema",
      "removeTheme" : "Eliminar tema"
    },
    "box" : "Cuadro",
    "line" : "Línea",
    "message" : "Mensaje",
    "openUrl" : "Abrir URL",
    "borderTypeList" : {
      "dotted" : "Punteado",
      "dashed" : "Discontinuo",
      "solid" : "Liso",
      "none" : "Ninguno"
    },
    "button" : "Botón",
    "emailNotification" : "Notificación por correo electrónico",
    "emailNotificationSubheader" : "Recibir un correo electrónico cuando alguien rellene tu formulario",
    "subject" : "Asunto",
    "emailTo" : "Correo electrónico (Para)",
    "senderName" : "Nombre del remitente",
    "senderNameWarning" : "Tu (nombre de la subcuenta) se añadirá si se deja en blanco",
    "emailError" : "Se requiere al menos una dirección de correo electrónico",
    "emailTooltip" : "La primera dirección de correo electrónico está destinada al campo «Para». Cualquier dirección de correo electrónico posterior se incluirá en el campo «Cc».",
    "clear" : "Borrar",
    "showNotificationsSettings" : "Mostrar configuración de notificaciones",
    "emailServicePaid" : "Esta función es un servicio de pago y generará cargos en función del uso.",
    "integration" : "Integración",
    "validation" : {
      "fieldRequired" : "El campo es obligatorio",
      "maxLengthExceeded" : "Máx. Longitud excedida ({max} carácter)"
    },
    "payment" : {
      "payments" : "Pagos",
      "connected" : "Conectado",
      "connect" : "Conectar",
      "liveModeOn" : "Modo en tiempo real",
      "status" : "Estado",
      "test" : "Prueba",
      "live" : "En tiempo real",
      "paymentFields" : "Campos de pago",
      "suggestAnAmount" : "Sugerir una cantidad",
      "selectCurrency" : "Seleccionar moneda",
      "tagActiveBGColor" : "Color de la etiqueta activa",
      "includeOtherAmount" : "Incluir otra cantidad",
      "footerInfo" : "Información de pie de página",
      "paymentType" : "Tipo de pago",
      "sellProducts" : "Vender productos",
      "customAmount" : "Cantidad personalizada",
      "collectPayment" : "Cobrar el pago",
      "generalSettings" : "Campos generales",
      "securePayments" : "*Bloquear y pagos seguros al 100%*",
      "error" : {
        "addMainProductFirst" : "Añadir a PRINCIPAL Producto primero",
        "priceNotFoundForBumpProduct" : "No se encontrado el Precio para el Producto ofrecido/complementario",
        "productAlreadyAdded" : "El Producto ya se ha añadido"
      },
      "product" : {
        "addProduct" : "Añadir producto",
        "productSettings" : "Configuración del producto",
        "selectProduct" : "Seleccionar producto",
        "editThisProduct" : "Para editar este producto",
        "clickHere" : "Haz clic aquí",
        "show" : "Mostrar",
        "description" : "Descripción",
        "image" : "Imagen",
        "layoutSettings" : "Configuración del diseño",
        "singleColumn" : "Columna única",
        "twoColumn" : "Dos columnas",
        "threeColumn" : "Tres columnas",
        "maxProductError" : "Se permiten un máximo de 20 productos en un formulario",
        "productSelectPlaceholder" : "Selecciona un producto",
        "orderConfirmation" : "Confirmación del pedido",
        "orderConfirmationWarning" : "Se mostrará una página de confirmación del pedido una vez que el pago se haya realizado correctamente",
        "quantity" : "Cantidad",
        "createProduct" : "Para crear un producto",
        "noProductsAdded" : "Todavía no se han añadido productos",
        "productsWillShowHere" : "Una vez que estés incluido en los productos, se mostrarán Derecha aquí",
        "chooseProductType" : "Seleccionar Tipo de Producto",
        "mainProduct" : "PRINCIPAL Producto"
      },
      "bumProduct" : {
        "price" : "Precio",
        "variant" : "Variante",
        "headline" : "Titular",
        "otoHeadline" : "Titular de la OTO",
        "otoText" : "OTO Cuerpo",
        "enableImage" : "Habilitar Imagen",
        "imageMessage" : "Cogeremos el Por defecto Producto Imagen",
        "orUploadADifferentImage" : "O Subir a Imagen diferente",
        "bumpProducts" : "Productos complementarios",
        "bumpProduct" : "Producto ofrecido/complementario",
        "enableBump" : "Habilitar complementario",
        "orderBumpStyle" : "Estilo Venta adicional",
        "classic" : "Clásico",
        "modern" : "Moderno",
        "icon" : "Icono",
        "bumpTemplate" : "Seleccionar Plantilla",
        "highlightText" : "Destacar Cuerpo",
        "showPrice" : "Mostrar Precio",
        "bumpPriceColor" : "Precio adicional",
        "bumpIconColor" : "Icono de complemento",
        "bumpBackgroundColor" : "Fondo de relieve",
        "highlightTextColor" : "Destacar Cuerpo",
        "headlineColor" : "Titular",
        "otoHeadlineColor" : "Titular de la OTO",
        "otoTextColor" : "OTO Cuerpo",
        "bumpBorderColor" : "Borde",
        "priceRequired" : "El precio es obligatorio",
        "headlineRequired" : "El titular es obligatorio",
        "bumpProductTooltip" : "Un Pequeño Complemento ofrecido durante el Proceso de pago a Multiplicar Ordenar Valor. Los clientes pueden incluirlo en un clic de Individual .",
        "templateOne" : "Plantilla 1",
        "templateTwo" : "Plantilla 2",
        "templateThree" : "Plantilla 3",
        "animationIcon" : {
          "none" : "Ninguno",
          "arrow" : "Flecha",
          "fire" : "Fuego",
          "plus" : "Más",
          "giftBox" : "Caja de regalo",
          "timer" : "Cuenta atrás",
          "cracker" : "Cracker",
          "snack" : "Tentempié",
          "partyBalloon" : "Globo de fiesta",
          "flash" : "Flash",
          "money" : "Moneda",
          "spaceShuttle" : "Transbordador Espacio"
        }
      },
      "coupons" : {
        "coupons" : "Cupones",
        "enableCoupon" : "Habilitar cupón",
        "couponAlignment" : "Alineación de cupones",
        "left" : "Izquierda",
        "right" : "Derecha",
        "fullWidth" : "Ancho completo",
        "tooltipMessage" : "Determina la posición de la introducción de un cupón entre los siguientes tipos"
      }
    },
    "addressSettings" : {
      "autoComplete" : "Completar automáticamente la dirección",
      "addressfields" : "Campos de dirección",
      "placeholderSearch" : "Buscar una dirección",
      "autoCompleteTooltip" : "Ofrece la capacidad de buscar y completar automáticamente la dirección.",
      "streetAddress" : "Dirección postal",
      "autoCompleteAddressTitle" : "Automático Terminar dirección",
      "newBadge" : "Nuevo",
      "defaultLabel" : "Dirección",
      "searchPlaceholder" : "Buscar Dirección",
      "mandataorySearch" : {
        "title" : "Obligatorio para seleccionar la dirección in Buscar Bar",
        "primaryText" : "Autocompletar solo para la Dirección postal",
        "secondaryText" : "Cuando Habilitado, Cuando un Usuario interactúa con la Dirección Campo, Entonces debe seleccionar una Dirección válida para continuar.",
        "secondaryText1" : "Cuando Deshabilitado Entonces pueden Proceder sin seleccionar una Dirección in la barra Buscar."
      }
    },
    "autoResponder" : "Respuesta automática",
    "autoResponderSubheader" : "Enviar un correo electrónico automatizado a la persona que envía el formulario (el correo electrónico incluye una copia de la información que ha introducido en el formulario)",
    "replyToEmail" : "Responder al correo electrónico",
    "open" : "Abierto",
    "won" : "Ganado",
    "lost" : "Perdido",
    "abandon" : "Abandonar",
    "selectAPipeline" : "Selecciona una secuencia",
    "stage" : "Paso",
    "status" : "Estado",
    "opportunityValue" : "Valor del cliente potencial",
    "createNewPipeline" : "Crear una nueva secuencia",
    "editOpportunitySettings" : "Editar la configuración de clientes potenciales",
    "contact" : "Contacto",
    "opportunity" : "Cliente potencial",
    "business" : "Empresa",
    "add" : "Añadir",
    "more" : "Más",
    "opportunityHeading" : "¿Dónde quieres que se actualice tu oportunidad?",
    "date" : {
      "dateSettings" : "Configuración de fecha",
      "dateFormat" : "Formato de fecha",
      "dateSeparator" : "Separador de fechas",
      "dateFormatTooltipMessage" : "Selecciona un formato de fecha. D representa el día, M el mes e Y el año",
      "dateSeparatorTooltipMessage" : "Selecciona un separador para separar el día, el mes y el año en el formato seleccionado en el formato de fecha",
      "disablePicker" : "Desactivar selector"
    },
    "restoreVersion" : "Restaurar versión",
    "versionHistory" : "Historial de versiones",
    "errorMessage" : "Error, vuelve a intentarlo",
    "version" : "Versión:",
    "currentVersion" : "Versión actual",
    "messageStyling" : "Estilo del mensaje",
    "validateEmailHeader" : "Validar el correo electrónico",
    "validateEmailDescription" : "El botón se hará visible una vez que el usuario introduzca su correo electrónico. Esta función está diseñada para ayudarte a generar clientes potenciales de calidad.",
    "validatePhoneHeader" : "Validar el teléfono",
    "validatePhoneDescription" : "El botón se hará visible una vez que el usuario introduzca su teléfono. Esta función está diseñada para ayudarte a generar clientes potenciales de calidad.",
    "validatePhoneWarning" : "Para habilitar la verificación OTP por SMS, asegúrate de que tu número de teléfono esté configurado en la configuración de tu ubicación",
    "addAnotherTnc" : "Add another T & C",
    "tnc1" : "T & C 1",
    "tnc2" : "T & C 2",
    "deleteCaps" : "DELETE",
    "deleteConfirmation" : "Type DELETE to confirm",
    "style" : {
      "formLayoutType" : "Tipo de formulario",
      "layoutType" : "Layout Type",
      "surveyType" : "Survey Type",
      "oneColumn" : "Una columna",
      "twoColumn" : "Dos columnas",
      "singleLine" : "Una sola línea",
      "fieldWidth" : "Ancho de campo",
      "labelAlignment" : {
        "labelAlignment" : "Alineación de etiquetas",
        "labelWidth" : "Ancho de la etiqueta"
      },
      "fieldSpacing" : "Espaciado entre campos",
      "color" : "color",
      "fontColor" : "Color de la fuente",
      "inputBackgroundColor" : "Color de fondo del comentario",
      "inputBorder" : "Borde de comentario/opinión",
      "layout" : "Diseño",
      "colorsAndBackground" : "Colores y fondo",
      "advanceSettings" : "Configuración avanzados",
      "inputField" : "Campo de entrada",
      "borderWidth" : "Ancho del borde",
      "borderColor" : "Color del borde",
      "borderStyle" : "Estilo de borde",
      "fontSize" : "Tamaño de la fuente",
      "fontWeight" : "Grosor de la fuente",
      "labelColor" : "Color de la etiqueta",
      "placeholderColor" : "Color del marcador de posición",
      "shortLabelColor" : "Color de etiqueta corta"
    },
    "replyToTooltip" : "Personaliza la dirección de correo electrónico predeterminada de Responder a mediante {'{'}{'{'}contact.email{'}'}{'}'} para habilitar las respuestas al contacto que envía el formulario.",
    "content" : "Contenido",
    "calculations" : "Cálculos",
    "uploadOptions" : "Opciones de subida",
    "opportunitySettingsWarning" : "Ajusta la configuración de oportunidades haciendo clic en el botón Edit Opportunity Settings.",
    "question" : "Pregunta",
    "createContactOnPartialSubmission" : "Crear contacto en envío parcial",
    "howItWorks" : "¿Cómo funciona?",
    "createContactOnPartialSubmissionDescription" : "Termina la diapositiva y haz clic en «Next». Se creará y almacenará automáticamente un nuevo contacto.",
    "swapWarningMessageSurvey" : "Las opciones de edición o intercambio afectarán a este campo personalizado en todos los lugares donde se use el campo. También puede restablecer la lógica condicional. ",
    "swapWarningMessageForm" : "Editar o intercambiar opciones afectará a este campo personalizado en todos los lugares donde se use. ",
    "migrationWarningMessage" : "This functionality has been migrated to the Survey Conditional Logic.",
    "optionLabel" : "Etiqueta de opción",
    "calculationValue" : "Valor de cálculo",
    "addOption" : "Añadir opción",
    "enableCalculations" : "Activar cálculos",
    "allowOtherOption" : "Allow Other Option",
    "productSelectionSubtext" : "Habilitar Individual O múltiple Selección de producto",
    "multi" : "Multi",
    "single" : "Individual",
    "productSelectionHeading" : "Selección de Producto",
    "spreadToColumns" : "Propagar a columnas",
    "columns" : "Columnas",
    "customstyle" : "Style",
    "standard" : "Standard",
    "bubble" : "Bubble",
    "integratePopup" : {
      "embedCode" : "Embed Code",
      "useInFunnelOrEmbedCode" : "Use in Funnel/ Embed Code",
      "iframeEmbed" : "Insertar de iframe",
      "funnel" : {
        "funnel" : "Embudo",
        "chooseStep" : "Seleccionar un paso",
        "copyCodeAndOpenFunnel" : "Copiar Código y Abrir Embudo"
      },
      "share" : {
        "share" : "Share",
        "shareViaSocials" : "Compartir Vía Redes sociales",
        "copyLink" : "Copiar enlace"
      },
      "email" : {
        "email" : "Correo electrónico",
        "shareViaEmail" : "Compartir Vía Correo electrónico",
        "emailButton" : "Correo electrónico",
        "blankTemplate" : "Plantilla en blanco",
        "emailMarketingTemplates" : "Plantillas de Marketing Correo electrónico",
        "or" : "O",
        "chooseTemplate" : "Choose from your templates",
        "continue" : "Continuar"
      }
    },
    "rating" : {
      "icon" : "Icono",
      "iconAlignment" : "Alineación de los Icono",
      "count" : "Recuento",
      "lowestRating" : "Mín. Valoración",
      "highestRating" : "Máx. Valoración",
      "iconSelectedState" : "Región/provincia/estado Seleccionado del Icono",
      "iconUnselectedState" : "Región/provincia/estado del Icono no seleccionado",
      "rating" : "Valoración",
      "ratingSettings" : "Configuración de Valoración",
      "calculationType" : {
        "calculationType" : "Cómo archivar Valoración Campos in Personalizado Campos",
        "calculationTypeTooltip" : "Cuando Tú Frecuencia algo 4 de 5 estrellas, significa: - Absoluto: 4 de 5 - Porcentaje: 80 - Fracción: 0,8",
        "absolute" : "Absoluto",
        "percentage" : "Porcentaje",
        "fraction" : "Fracción"
      }
    },
    "desktopMode" : "Modo de escritorio",
    "mobileMode" : "Modo móvil",
    "versions" : "Variantes",
    "advanced" : "Advanced",
    "edit" : "Edit",
    "settings" : "Settings",
    "submissions" : "Submissions",
    "undo" : "Undo",
    "redo" : "Redo",
    "confirmationMessage" : "Confirmation Message",
    "deleteOption" : "Opción de Borrar",
    "deleteConfirmationModal" : {
      "defaultDescription" : "Eliminar una opción afectará a este Campo Personalizado en todas las plazas donde se use el Campo. ¿Estás seguro de que deseas borrarlo?",
      "validationMessage" : "Introduce Borrar para guardar.",
      "validationError" : "Introduce Borrar"
    },
    "disqualifyImmediately" : "Disqualify Immediately",
    "disqualifyAfterSubmit" : "Disqualify After Submit",
    "generalSettings" : "Configuración General",
    "advancedSettings" : "Configuración avanzados",
    "customFieldName" : "Personalizado Sector/industria Nombre",
    "customFieldNameTooltip" : "Este Nombre de sector/industria es único por Personalizado Sector/industria.",
    "uniqueKey" : "Clave única",
    "uniqueKeyTooltip" : "Esta clave es única por Personalizado Sector/industria.",
    "survey" : {
      "layoutType" : "Survey Type",
      "oneQuestionPerPage" : "One Question at a Time",
      "allQuestionsOnePage" : "Many at a Time"
    },
    "quizQuestions" : "Cuestionario Consultar",
    "choiceElements" : "Componentes seleccionados",
    "otherElements" : "Otro Componentes",
    "listEditor" : {
      "prefillValueHeader" : "Valor de Prerrellenar",
      "labelPlaceholder" : "Etiqueta",
      "valuePlaceholder" : "Valor",
      "optionRequiredError" : "La opción Campo es Obligatorio"
    },
    "field" : "Campo",
    "scoreEditor" : {
      "addFieldPlaceholder" : "Añadir Campo",
      "fieldLabel" : "Campo",
      "numberLabel" : "número"
    },
    "fileUploadEditor" : {
      "fileTypes" : "Tipos de Archivo",
      "all" : "cada",
      "pdf" : "PDF",
      "docxDoc" : "DOCX/DOC",
      "png" : "PNG",
      "gif" : "GIF",
      "jpgJpeg" : "JPG/JPEG",
      "xlsCsv" : "XLS/CSV"
    },
    "ok" : "De acuerdo",
    "select" : "Seleccionar",
    "allowMultipleFiles" : "Habilitar múltiples Archivos",
    "maxFileLimit" : "Límite Máx. de Archivo",
    "privacyPolicy" : "Política de privacidad",
    "termsOfService" : "Condiciones del servicio"
  },
  "fields" : {
    "quizQuestions" : {
      "singleChoice" : "Elección Individual",
      "multipleChoice" : "Elección múltiple",
      "yesNo" : "Sí / No",
      "shortAnswer" : "Corto Respondido",
      "longAnswer" : "Respondido largo",
      "number" : "número",
      "singleDropdown" : "Menú desplegable Individual",
      "multiDropdown" : "Menú desplegable múltiple"
    },
    "personal" : {
      "fullName" : "Nombre Completo",
      "firstName" : "Nombre",
      "lastName" : "Último nombre",
      "dateOfBirth" : "Fecha de nacimiento",
      "phone" : "Teléfono",
      "email" : "Gmail"
    },
    "submit" : {
      "button" : "Botón"
    },
    "integration" : {
      "sellProducts" : "Vender productos",
      "collectPayment" : "Cobrar el Pago"
    },
    "address" : {
      "address" : "Dirección",
      "streetAddress" : "Dirección postal",
      "city" : "Ciudad",
      "state" : "Región/provincia/estado",
      "country" : "País",
      "postalCode" : "Código postal",
      "organization" : "Grupo",
      "website" : "Sitio web",
      "websitePlaceholder" : "La URL web va aquí"
    },
    "text" : {
      "singleLine" : "Línea Individual",
      "multiLine" : "Multi Línea",
      "textBoxList" : "Enviar mensaje de texto Cuadrado Lista"
    },
    "choiceElements" : {
      "singleDropdown" : "Menú desplegable Individual",
      "multiDropdown" : "Menú desplegable múltiple",
      "checkbox" : "Casilla de verificación",
      "radio" : "Botón de opción"
    },
    "customized" : {
      "text" : "Enviar mensaje de texto",
      "html" : "Html",
      "htmlPlaceholder" : "El HTML Personalizado va aquí",
      "captcha" : "Captcha",
      "source" : "Fuente",
      "termsAndConditions" : "Términos y condiciones",
      "termsAndConditionsPlaceholder" : "Acepto los términos y condiciones Emitido Vía la empresa. Vía proporcionando mi Número de teléfono, acepto a Heredar Enviar mensaje de texto mensajes De la empresa.",
      "score" : "Puntuación"
    },
    "other" : {
      "image" : "Imagen",
      "fileUpload" : "Subir de Archivo",
      "monetary" : "Monetario",
      "number" : "número",
      "datePicker" : "Selector de Fecha",
      "signature" : "Firma"
    },
    "customstyle" : "Style",
    "standard" : "Standard",
    "bubble" : "Bubble"
  },
  "survey" : {
    "typeOfBuilder" : "Encuesta",
    "survyeStyle" : "Estilo de encuesta",
    "surveyName" : "Nombre de encuesta",
    "surveyElement" : "Elemento de encuesta",
    "addSurveyElement" : "Añadir elemento de encuesta",
    "cloneSlide" : "Clonar diapositiva",
    "unsavedAlertMessage" : "Hay trabajo sin guardar en la encuesta. ¿Seguro que quieres abandonar y descartar todo el trabajo que no has guardado?",
    "thirdPartyScriptAlertMessage" : "Las secuencias de código de terceros dentro del bloque HTML pueden proporcionar una funcionalidad potente, pero también conllevan riesgos para la privacidad, la seguridad, el rendimiento y el comportamiento de la página. Por lo tanto, te recomendamos que revises el contenido de este script antes de guardarlo en la encuesta.",
    "integrateHeader" : "Integrar encuesta",
    "integrateSubHeader" : "Usa las siguientes opciones para integrar tu encuesta personalizada en tu sitio web",
    "integrateCopyLinkMessage" : "Copia el enlace a continuación y compártelo fácilmente donde quieras.",
    "onSurveySubmission" : "En el envío de encuestas",
    "surveySettings" : "Configuración de la encuesta",
    "oneQuestionAtTime" : "Una pregunta cada vez",
    "backButton" : "Botón de retroceso",
    "backButtonTooltipMessage" : "Back button will help users to move to the previous slide",
    "disableAutoNavigation" : "Desactivar la navegación automática",
    "disableAutoNavigationTooltipMessage" : "Navega automáticamente al Siguiente Deslizar Después a Usuario responde.",
    "autoNavigation" : "Navegación Automático",
    "autoNavigationTooltipMessage" : "Navega automáticamente al Siguiente Deslizar Después a Usuario responde.",
    "progressBar" : "Barra de progreso",
    "progressBarTooltipMessage" : "Turning this off will remove the Progress Bar from the survey",
    "disableAnimation" : "Desactivar la animación",
    "disableAnimationTooltipMessage" : "Al activar esta opción, se desactivará la animación de transición de la diapositiva",
    "scrollToTop" : "Desplazarse hasta arriba",
    "scrollToTopTooltipMessage" : "Si esta opción está activada, la encuesta se desplazará hasta la parte superior de la siguiente diapositiva",
    "footerHTML" : "Pie de página HTML",
    "footerHTMLMessage" : "Puedes escribir CSS personalizado (usando una etiqueta de estilo) y HTML dentro del mismo cuadro",
    "editFooter" : "Editar pie de página",
    "disqualifySettings" : "Disqualify Settings",
    "disqualifyImmediately" : "Descalificar inmediatamente",
    "disqualifyAfterSubmit" : "Descalificar después de enviar",
    "disqualifyImmediatelyLabel" : "Immediately",
    "disqualifyAfterSubmitLabel" : "After Submit",
    "slideConflictAlertMessage" : "Esta diapositiva contiene varias preguntas que tienen una lógica establecida. Esto puede provocar algún comportamiento no deseado.",
    "addSlide" : "Añadir diapositiva",
    "settings" : "Configuración",
    "delete" : "Eliminar",
    "slideDeleteAlertMessage" : "¿Seguro que quieres eliminar esta diapositiva?",
    "slideDeleteBetweenAlertMessage" : "Esta acción reorganizará las demás diapositivas. ¿Seguro que quieres eliminar esta diapositiva?",
    "slideLabel" : "Slide {n}",
    "slideName" : "Nombre de la diapositiva",
    "slidePosition" : "Posición de diapositiva",
    "jumpTo" : "Saltar a",
    "jumpToSubText" : "Jump to a specific slide",
    "enableTimezoneSurvey" : "Al activar esta opción, se capturará la información de la zona horaria de la persona que envía la encuesta.",
    "footer" : {
      "footer" : "Pie de página",
      "enableNewFooter" : "Habilitar nuevo pie de página",
      "stickToSurvey" : " Cíñete a la encuesta",
      "backgroundFill" : "Relleno de fondo",
      "footerHeight" : "Altura del pie de página",
      "enableProgressBar" : "Habilitar la barra de progreso",
      "buttons" : "Botones",
      "button" : "Botón",
      "buttonType" : "Tipo de botón",
      "fillNext" : "Rellenar (siguiente)",
      "fillPrevious" : "Rellenar (anterior)",
      "fillSubmit" : "Rellenar (Enviar)",
      "textColor" : "Texto del botón",
      "position" : "Posición",
      "previousText" : "Anterior (texto)",
      "nextText" : "Siguiente (texto)",
      "submitText" : "Enviar (texto)",
      "fillComplete" : "Rellenar completado",
      "fillInactive" : "Rellenar inactivo",
      "footerType" : "Tipo de pie de página",
      "stickToCard" : "Fijar a la tarjeta",
      "stickToPage" : "Fijar a la página",
      "stepTextColor" : "Paso Cuerpo Color",
      "progressBarFill" : "Barra de progreso Rellenar",
      "progressBarInactive" : "Barra de progreso Inactivo",
      "arrowFill" : "Rellenar de Flecha",
      "submitColorMobile" : "Enviar (Color)",
      "arrowFillColor" : "Color de Rellenar de la Flecha"
    },
    "surveyNotfication" : "Notificación de encuesta",
    "style" : {
      "surveyPadding" : "Margen de la encuesta"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Survey",
      "share" : {
        "openFormLink" : "Abrir Enlace de la Encuesta"
      },
      "email" : {
        "emailSubheader" : "Crea un correo electrónico en blanco e inserta tu encuesta, O selecciona una plantilla e insértala inmediatamente."
      }
    },
    "autoResponderSubheader" : "Enviar un correo electrónico automatizado a la persona que envía el formulario (el correo electrónico incluye una copia de la información que ha introducido en el formulario)",
    "switchToOneQuestionAtTimeOn" : "Habilitar «Una pregunta por fecha» interrumpe tu Lógica del condicional real",
    "switchToOneQuestionAtTimeOff" : "Deshabilitar «Una pregunta a la fecha» afecta a tu Lógica Config. condicional.",
    "switchToOneQuestionAtTimeOnWarning" : "Algunas condiciones ya no funcionarán como se esperaba Cuando las preguntas son asistidos una a una Fecha.",
    "switchToOneQuestionAtTimeOffWarning" : " Algunas condiciones diseñadas para Flujo de preguntas individuales dejarán de funcionar correctamente.",
    "createContactOnPartialSubmissionSubText" : "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Survey."
  },
  "form" : {
    "typeOfBuilder" : "Formulario",
    "formStyle" : "Estilo del formulario",
    "formElement" : "Elemento de formulario",
    "addFormElement" : "Añadir elemento de formulario",
    "addConditionalLogic" : "Añadir lógica condicional",
    "openConditionalLogic" : "Open Conditional Logic",
    "inlineForm" : "Formulario en línea",
    "formName" : "Nombre del formulario",
    "fullScreenMode" : "Modo de pantalla completa",
    "fullScreenModetooltip" : "Si esta opción está activada, el formulario se expandirá por todo el ancho de su contenedor y se extenderá hasta el borde del área de incrustación sin sobrepasar el ancho del formulario.",
    "enableTimezoneForm" : "Al activar esta opción, se capturará la información de la zona horaria de la persona que envía el formulario",
    "formSettings" : "Configuración del formulario",
    "unsavedAlertMessage" : "Hay trabajo sin guardar en el formulario. ¿Seguro que quieres abandonar y descartar todo el trabajo que no has guardado?",
    "thirdPartyScriptAlertMessage" : "Las secuencias de código de terceros dentro del bloque HTML pueden proporcionar una funcionalidad potente, pero también conllevan riesgos para la privacidad, la seguridad, el rendimiento y el comportamiento de la página. Por lo tanto, te recomendamos que revises el contenido de este script antes de guardarlo en la encuesta.",
    "onFormSubmission" : "En el envío del formulario",
    "integrateForm" : "Integrar formulario",
    "embedlayoutType" : "Tipo de Diseño Insertar",
    "embedlayoutTypeSubMessage" : "Selecciona un diseño para incrustarlo en un embudo o en un sitio web externo",
    "triggerType" : "Tipo de activador",
    "showOnScrolling" : "Mostrar al desplazarse",
    "showAfter" : "Mostrar después",
    "seconds" : "segundos",
    "alwaysShow" : "Mostrar siempre",
    "activationOptions" : "Opciones de activación",
    "activateOn" : "Activar el",
    "visit" : "visitar",
    "alwaysActivated" : "Siempre activado",
    "deactivationOptions" : "Opciones de desactivación",
    "deactivateAfterShowing" : "Desactivar después de mostrar",
    "times" : "veces",
    "deactiveOnceLeadCollected" : "Desactivar una vez que se haya recopilado el cliente potencial",
    "neverDeactivate" : "No desactivar nunca",
    "copyEmbedCode" : "Copiar código de incrustación",
    "copyFormLink" : "Copiar enlace del formulario",
    "openFormLink" : "Abrir enlace del formulario",
    "inline" : "En línea",
    "inlineDescription" : "Aparece un formulario en línea junto con el contenido de la página como elemento nativo. No se superpone y no se puede cerrar ni minimizar.",
    "inlineHoverDescription" : "Aparece un formulario en línea junto con el contenido de la página como elemento nativo. No se superpone y no se puede cerrar ni minimizar.",
    "popup" : "Ventana emergente",
    "popupDescription" : "Una ventana emergente muestra el formulario como una superposición dentro de una caja de luz. No se puede minimizar, pero sí cerrar.",
    "popupHoverDescription" : "Una ventana emergente muestra el formulario como una superposición dentro de una caja de luz. No se puede minimizar, pero sí cerrar.",
    "politeSlideIn" : "Ventana deslizante respetuosa",
    "politeSlideInDescription" : "Aparece una ventana deslizante en la parte inferior de la pantalla, que desaparece una vez cerrada.",
    "politeSlideInHoverDescription" : "Aparece en la parte inferior de la pantalla y desaparece una vez cerrada",
    "stickySidebar" : "Barra lateral fija",
    "stickySidebarDescription" : "Aparecerá una barra lateral fija en el lateral de la pantalla que puede minimizarse para convertirse en una pestaña fijada al lateral de la ventana",
    "stickySidebarHoverDescription" : "Aparecen en el lateral de la pantalla y pueden minimizarse para convertirse en una pestaña fijada al lateral de la ventana",
    "allowMinimize" : "Permitir minimizar",
    "conditonalLogic" : {
      "conditions" : "Condiciones",
      "noExistingCondition" : "Todavía no existen condiciones",
      "freeRoamMessage" : "Puedes ir por libre sin reglas… al menos, por ahora.",
      "addNewCondition" : "Añadir nueva condición",
      "redirectToUrl" : "Redirigir a la URL",
      "displayCustomMessage" : "Mostrar un mensaje personalizado",
      "disqualifyLead" : "Descalificar al cliente potencial",
      "showHideFields" : "Mostrar/Ocultar campos",
      "jumpTo" : "Jump To",
      "redirectToUrlSubText" : "Redirigir al usuario después del envío",
      "displayCustomMessageSubText" : "Mostrar mensajes basados en las entradas de Activado Usuario",
      "disqualifyLeadSubText" : "Filtrar las entradas bajo condiciones específicas",
      "showHideFieldsSubText" : "Modificar el campo de visibilidad dinámicamente",
      "openBelowUrl" : "Abre la URL a continuación",
      "showCustomMessage" : "Mostrar mensaje personalizado",
      "alertConditionDelete" : "¿Seguro que quieres eliminar esta condición?",
      "deleteCondition" : "Eliminar condición",
      "conditionExecutedMessage" : "Las condiciones se ejecutarán en orden descendente.",
      "allOperationOptions" : {
        "isEqualTo" : "Es igual a",
        "isNotEqualTo" : "No es igual a",
        "contains" : "Contiene",
        "startsWith" : "Empieza por",
        "endsWith" : "Termina con",
        "isEmpty" : "Está vacío",
        "isFilled" : "Está rellenado",
        "before" : "Antes",
        "after" : "Después",
        "greaterThan" : "Mayor que",
        "lessThan" : "Menor que"
      },
      "logic" : {
        "if" : "Si",
        "then" : "Entonces",
        "and" : "Y",
        "or" : "O"
      },
      "phoneAlertMessage" : "Para buscar números de teléfono con un código de país, debes incluir explícitamente el símbolo «+» en la consulta de búsqueda.",
      "deleteAlertMessage" : "¿Seguro que quieres eliminar este campo? También se eliminará la condición asociada a este campo.",
      "deleteField" : "Eliminar campo",
      "jumpToDescription" : "Jump to a specific slide when conditions are met",
      "jumpToSlide" : "Jump To Slide",
      "selectSlideToJumpTo" : "Select slide to jump to",
      "selectedSlide" : "Selected slide"
    },
    "minimizedTitlePlaceholder" : "Título minimizado",
    "dragYourElementFromLeft" : "Arrastra tus elementos aquí desde la izquierda",
    "formNotification" : "Notificación del formulario",
    "style" : {
      "formPadding" : "Margen del formulario"
    },
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Form",
      "share" : {
        "openFormLink" : "Abrir Enlace del Formulario"
      },
      "email" : {
        "emailSubheader" : "Crea un correo electrónico en blanco e inserta tu formulario, O selecciona una plantilla e insértala inmediatamente."
      }
    },
    "choosePosition" : "Seleccionar Estado"
  },
  "quiz" : {
    "quizElement" : "Elemento del cuestionario",
    "quizNotification" : "Notificación del cuestionario",
    "viewAndCustomise" : "Ver y personalizar",
    "categoryAndScore" : "Categoría y puntuación",
    "provideFeedback" : "Proporcionar comentarios",
    "addQuizElement" : "Añadir elemento del cuestionario",
    "typeOfBuilder" : "Cuestionario",
    "addQuestions" : "Añadir preguntas",
    "dragAndDropQuestion" : "Arrastrar y suelta aquí un elemento de Pregunta .",
    "addNewPage" : "Añadir Nueva página",
    "editTemplate" : "Editar Plantilla",
    "clonePage" : "Clone Page",
    "category" : {
      "category" : "Categoría",
      "watchVideo" : "¡Mira este vídeo para obtener más información Acerca de cómo la categoría afecta a los resultados Página!",
      "useCategoryWhen" : "Utilizar categorías Cuando",
      "manageCategories" : "Gestionar las Categorías",
      "howItWorks" : "¿Cómo funciona esto? 🤔",
      "howItWorks2" : "Cómo funciona esto",
      "addCategoryMessage" : "Añadir a nueva categoría",
      "assignCategoryMessage" : "Asignar una categoría a cada opción",
      "editResultsMessage" : "Mostrar la categoría puntuación in el Resultado página",
      "addCategory" : "Añadir Categoría",
      "deleteCategoryAlertMessage" : "Eliminar una categoría dará como resultado el resto de esa categoría in cada opciones",
      "editOrAddNewCategories" : "Tú puedes Editar o incluir nuevas categorías",
      "toEvaluateTheResponder" : "Para comparar el respondedor en función de Activado, varios factores",
      "showMultipleCategoryScore" : "Mostrar múltiples categorías de puntuación in el Resultado página",
      "displayVaryingContent" : "Visualización variando el Contenido Activado de los resultados Página según Activado la Categoría nivel de puntuación",
      "theOptionFieldIsRequired" : "The option field is required",
      "addManage" : "Añadir / Gestionar"
    },
    "quizSettings" : "Configuración del cuestionario",
    "onQuizSubmission" : "En el envío del cuestionario",
    "settings" : "Configuración",
    "deletePage" : "Eliminar página",
    "quizResult" : {
      "resultTemplate" : "Plantilla de resultados",
      "quizResultAlertMessage" : "La página de resultados elegida se mostrará una vez que se complete el cuestionario"
    },
    "autoResponderSubheader" : "Enviar un correo electrónico automatizado a la persona que envía el cuestionario (el correo electrónico incluye una copia de la información que ha introducido en el cuestionario)",
    "integrateHeader" : "Integrar cuestionario",
    "integrateSubHeader" : "Usa las siguientes opciones para integrar tu cuestionario personalizado en tu sitio web",
    "integrateCopyLinkMessage" : "Copia el enlace a continuación y compártelo fácilmente donde quieras.",
    "pageLabel" : "Page {n}",
    "pageName" : "Nombre de la página",
    "pagePosition" : "Posición de la página",
    "createContactOnPartialSubmissionSubText" : "Creates a contact when a user clicks \"Next\" on any slide — even if they don't finish the Quiz.",
    "integratePopup" : {
      "shareOrEmbed" : "Embed or Share Quiz",
      "share" : {
        "openFormLink" : "Abrir Enlace del cuestionario"
      },
      "email" : {
        "emailSubheader" : "Crea un Correo electrónico en blanco e Insertar tu cuestionario, O Seleccionar una Plantilla e Insertarla inmediatamente."
      }
    }
  }
}
